

















































import Vue from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Heading
  },
  props: {
    heading: {
      type: String,
      required: true
    },
    subHeading: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      background: require("@/assets/images/Pages/Error/Molecules/Layout/background.svg")
    };
  },
  methods: {
    handleClickPageBack() {
      this.$router.go(-1);
      this.$emit("clickPageBack");
    },
    handleClickHelpCenter() {
      this.$emit("clickHelpCenter");
    }
  }
});
